var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge-status",class:_vm.ativo ? 'badge-status--ativo' : 'badge-status--inativo'},[_vm._v(" "+_vm._s(_vm.ativo ? 'Ativo' : 'Inativo')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }